import { apiClient } from "@/lib/api/http"

interface Envelope<T> {
  success: boolean
  statusCode: number
  message: string
  data: T
}

export interface Complain {
  id: string
  category: "PRODUCT_QUALITY" | "PAYMENT" | "LOGISTICS" | "COMMUNICATION" | "OTHER"
  message: string
  status: "OPEN" | "IN_PROGRESS" | "RESOLVED" | "CLOSED" | "REJECTED"
  resolutionNote?: string
  documentUrls: string[]
  createdAt: string
  updatedAt: string
  user?: {
    id: string
    name: string
    email: string
    role: string
  }
}

export async function createComplain(
  payload: {
    category: "PRODUCT_QUALITY" | "PAYMENT" | "LOGISTICS" | "COMMUNICATION" | "OTHER"
    message: string
    documentUrls?: string[]
  },
  token: string
): Promise<any> {
  const { data: envelope } = await apiClient.post<Envelope<any>>(
    "/complain",
    payload,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  return envelope.data
}

export async function getMyComplains(token: string): Promise<Complain[]> {
  const { data: envelope } = await apiClient.get<Envelope<Complain[]>>(
    "/complain/my-complains",
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  return envelope.data || []
}

export async function getAllComplains(token: string): Promise<Complain[]> {
  const { data: envelope } = await apiClient.get<Envelope<Complain[]>>(
    "/complain",
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  return envelope.data || []
}

export async function getComplainById(id: string, token: string): Promise<Complain> {
  const { data: envelope } = await apiClient.get<Envelope<Complain>>(
    `/complain/${id}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  return envelope.data
}

export async function getComplainCount(status: string, token: string): Promise<{ complainCount: Record<string, number> }> {
  const { data: envelope } = await apiClient.get<Envelope<{ complainCount: Record<string, number> }>>(
    `/complain/count/${status}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  return envelope.data
}
export async function updateComplainStatus(
  id: string,
  payload: { status: string; resolutionNote?: string },
  token: string
): Promise<any> {
  const { data: envelope } = await apiClient.patch<Envelope<any>>(
    `/complain/${id}/status`,
    payload,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  return envelope.data
}
